import axios from 'axios';
import { ApiUrl } from './constants';

/** NURO 光マイページBFFのAPIベースURL */
const baseURL = ApiUrl.DOMAIN;

/**
 * NURO 光マイページBFFを呼出すためのaxiosインスタンス
 * nurohikari-mypage-apiへのリクエストに共通で使用される。
 * リクエストインターセプターでContent-Typeヘッダを自動設定し、
 * レスポンスインターセプターでエラー時に例外をスローする。
 */
const instance = axios.create({
  baseURL,
});

// リクエスト時にContent-TypeヘッダをJSONとして自動付与する
instance.interceptors.request.use((config) => {
  if (config.headers) {
    // eslint-disable-next-line no-param-reassign
    config.headers['content-type'] = 'application/json';
  } else {
    // eslint-disable-next-line no-param-reassign
    config.headers = { 'content-type': 'application/json' };
  }

  return config;
});

// APIエラー時は例外をそのままスローし、呼び出し元でハンドリングさせる
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    throw error;
  }
);

export default instance;
